export default {"src":"/_next/static/media/Banks-credit-unions.1c237749.svg","height":1600,"width":1600};